import { createFileRoute } from '@tanstack/react-router';
import VendorView from '../admin/vendor/view';
export const Route = createFileRoute('/admin/vendors/')({ component: VendorView });
